<template>
  <div>
    <!-- <v-card> -->
    <div class="message-container">
      <div class="title-participant">
        <v-row>
          <v-col :cols="8" :xl="6" :lg="6" :md="7" :sm="7" :xs="7">
            <div class="headerData title ml-3">Student Name</div>
          </v-col>
          <v-col :cols="4" :xl="6" :lg="6" :md="5" :sm="5" :xs="5">
            <div class="headerData title text-right mr-3">Joined</div>
          </v-col>
        </v-row>
      </div>

      <div class="message-scroll">
        <div class="message-detail px-4 pl-6 pt-0">
          <!-- <div class="message-box" >
          <v-card color="white" elevation="0">
            <div
              class="chat-message"
            >
              <div class="chat-name">{{participant.student.displayName}}</div>
            </div>
            <div
              class="chat-time"
            >
              <div>Joined</div>
            </div>
          </v-card>
          </div>-->
          <!-- <v-row>
            <v-col :cols="8" :lg="10" :md="10" :sm="8">
              Student Name
              </v-col>
            <v-col :cols="4" :lg="2" :md="2" :sm="4">
              <div>
                Joined
              </div>
            </v-col>
          </v-row>-->
          <div class="message-box" :key="key" v-for="(participant, key) in participants">
            <!-- <v-card color="white" elevation="0">
            <v-row>
            <v-col :cols="2" :lg="2" :md="2" :sm="2">
              <div class="chat-avatar">
                <v-avatar :size="55" class="text-top">
                  <img :src="participant.student.image" />
                </v-avatar>
              </div>
              </v-col>
            <v-col :cols="8" :lg="8" :md="8" :sm="8">
                <div
                class="chat-message"
              >
                <div class="chat-name">{{participant.student.displayName}}</div>
                <div class="gray-font">{{participant.student.email}}</div>
              </div>
            </v-col>
            <v-col :cols="2" :lg="2" :md="2" :sm="2">
              <div>
                <div
                class="gray-font"
              >
                <div>{{(new Date(participant.created_at)).getHours() }}:{{ (new Date(participant.created_at)).getMinutes() >= 10 ? (new Date(participant.created_at)).getMinutes() :`0${(new Date(participant.created_at)).getMinutes()}` }}</div>
              </div>
              </div>
            </v-col>
          </v-row>
            </v-card>-->
            <v-card color="white" elevation="0">
              <div class="container-left">
                <v-avatar :size="50">
                  <img :src="participant.student.image" />
                </v-avatar>
              </div>
              <div
                class="container-right subtitle-1"
              >{{(new Date(participant.created_at)).getHours() }}:{{ (new Date(participant.created_at)).getMinutes() >= 10 ? (new Date(participant.created_at)).getMinutes() :`0${(new Date(participant.created_at)).getMinutes()}` }}</div>
              <div class="container-center">
                <div class="title">{{participant.student.displayName}}</div>
                <div class="subtitle-2">{{participant.student.email}}</div>
              </div>
            </v-card>
            <!-- <v-card color="white" elevation="0">
              <div class="chat-avatar">
                <v-avatar :size="50" class="text-top">
                  <img :src="participant.student.image" />
                </v-avatar>
              </div>
              <div
                :class="participant.userID === ownerID ? 'chat-message owner-message':'chat-message'"
              >
                <div class="chat-name">{{participant.student.displayName}}</div>
                <div>{{participant.student.email}}</div>
              </div>
              <div
                :class="participant.userID === ownerID ? 'chat-time owner-message':'chat-time'"
              >
                <div>{{(new Date(participant.created_at)).getHours() }}:{{ (new Date(participant.created_at)).getMinutes() >= 10 ? (new Date(participant.created_at)).getMinutes() :`0${(new Date(participant.created_at)).getMinutes()}` }}</div>
              </div>
            </v-card>-->
          </div>
        </div>
      </div>
    </div>
    <!-- </v-card> -->
  </div>
</template>
<script>
import { getJoinedLearner } from "@/service/course/live";
// var coursesRef = database
//   .ref("/courses")
//   .child("/course12")
//   .child("/live30");

// var onlineUserRef = database.ref("/onlineUser").child("/live30");

// var connectedRef = database.ref(".info/connected");
// import { getLiveStreamStudio } from "@/service/course/live";
// import $ from "jquery";
export default {
  name: "login",
  props: {
    courseId: {
      type: String
    },
    liveId: {
      type: String
    }
  },
  data: () => ({
    participants: []
  }),
  async mounted() {
    let result = await getJoinedLearner({ idlivestream: this.liveId });
    this.participants = result;
  },
  computed: {},
  methods: {}
};
</script>
<style lang="scss" scoped>
.message-container {
  position: relative;
  // padding: 12px;
  height: 77vh;
}
.message-scroll {
  height: 80vh;
  overflow: hidden;
}
.message-detail {
  /* background-color: ghostwhite; */
  // padding-left: 12px;
  // padding-right: 12px;
  height: 85%;
  /* margin-bottom: 10px; */
  overflow-y: scroll;
  /* overflow: hidden; */
}
.message-detail:hover {
  /* background-color: ghostwhite; */
  /* height: 470px; */
  /* margin-bottom: 10px; */
  /* overflow-y: scroll; */
  /* overflow: hidden; */
}
.chat-avatar {
  // padding: 10px 10px 0px 10px;
  // width: 50px;
  display: inline-table;
}
.chat-message {
  // padding: 10px;
  // display: inline-table;
  font-size: 18px;
  /* width: 50px; */
}
.chat-name {
  font-weight: bold;
}
.chat-time {
  // font-weight: bold;
  padding: 10px;
  width: 80px;
  float: right;
  text-align: right;
}
.owner-message {
  color: white;
}
.gray-font {
  color: #888888;
}
/* .send-message-container{

} */
.send-message-container {
  /* position: relative; */
  /* height: 200px; */
  /* border: 3px solid red; */
  /* position: absolute; */
  /* width: 100%; */
  /* bottom: 10px; */
  position: absolute;
  bottom: 10px;
  width: 92%;
}

.send-message-input {
  /* position: absolute;
  bottom: 10px; */
  /* border: 3px solid #8AC007; */
  display: inline-block;
}
.send-message-btn {
  float: right;
  /* display: inline-block; */
  width: 90px;
}
.message-box {
  // padding-left: 10px;
  // padding-right: 10px;
  margin-bottom: 15px;
}
.title-participant {
  padding-left: 10px;
  padding-right: 10px;
  margin-bottom: 15px;
}
.v-card:not(.v-sheet--tile):not(.v-card--shaped) {
  border-radius: 8px;
}
.send-container {
  padding-left: 10px;
  padding-right: 10px;
}
.text-top {
  vertical-align: text-top;
}
.container-left {
  // height: 608px;
  width: 70px;
  // background:red;
  float: left;
}

.container-right {
  // background:blue;
  // height: 608px;
  width: 60;
  float: right;
}
.headerData {
  color: #9d9d9d;
}

.container-center {
  // width: auto; //or any width that you want
  width: calc(100% - 70px - 60px);
  margin: 0 auto;
  // background:yellow;
}
</style>